var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4615 4H0.538462C0.239615 4 0 4.2225 0 4.5V14C0 15.1025 0.966539 16 2.15385 16H11.8462C13.0335 16 14 15.1025 14 14V4.5C14 4.2225 13.7604 4 13.4615 4ZM12.9231 14C12.9231 14.5525 12.4412 15 11.8462 15H2.15385C1.55885 15 1.07692 14.5525 1.07692 14V5H12.9231V14ZM0.538462 3H13.4615C13.7604 3 14 2.7775 14 2.5C14 2.2225 13.7604 2 13.4615 2H9.69231C9.69231 0.8975 8.72577 0 7.53846 0H6.46154C5.27423 0 4.30769 0.8975 4.30769 2H0.538462C0.239615 2 0 2.2225 0 2.5C0 2.7775 0.239615 3 0.538462 3ZM6.46154 1H7.53846C8.13346 1 8.61539 1.4475 8.61539 2H5.38462C5.38462 1.4475 5.86654 1 6.46154 1ZM6.46154 13V7C6.46154 6.7225 6.70115 6.5 7 6.5C7.29885 6.5 7.53846 6.7225 7.53846 7V13C7.53846 13.2775 7.29885 13.5 7 13.5C6.70115 13.5 6.46154 13.2775 6.46154 13ZM9.15385 13V7C9.15385 6.7225 9.39346 6.5 9.69231 6.5C9.99115 6.5 10.2308 6.7225 10.2308 7V13C10.2308 13.2775 9.99115 13.5 9.69231 13.5C9.39346 13.5 9.15385 13.2775 9.15385 13ZM3.76923 13V7C3.76923 6.7225 4.00885 6.5 4.30769 6.5C4.60654 6.5 4.84615 6.7225 4.84615 7V13C4.84615 13.2775 4.60654 13.5 4.30769 13.5C4.00885 13.5 3.76923 13.2775 3.76923 13Z",
    fill: "#114BC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.3b1bf43ac84142d07207cb167aa36197.svg";
export { ForwardRef as ReactComponent };